import markdownIt from 'markdown-it'
import markdownItChart from 'markdown-it-charts'

const pluginMap = {
  'chart': markdownItChart
}

class Engine {
  constructor(options = {}, plugins = []) {
    this.mdc = markdownIt(options)
    if (options.linkify === true) {
      this.mdc.linkify.set({ fuzzyLink: false })
    }
    plugins.filter((plugin) => pluginMap[plugin]).forEach((plugin) => {
      this.mdc.use(pluginMap[plugin])
    })
  }
}

export default Engine
